module.exports = __webpack_public_path__ + "static/img/p5bg.bffaf82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/p5bg.png
// module id = D/8a
// module chunks = 0